import { useMediaLibDialogCtx } from "@editor/modules/media-lib/ctx";
import { useMediaLibDialogStoreShallow } from "@editor/modules/media-lib/stores";
import {
  type IMediaLibDialogItem,
  MediaLibPresetEnum,
} from "@editor/modules/media-lib/types";
import { Gifs } from "../../gifs";
import type { IGifs } from "../../gifs/types";

export const MediaDialogGifs = () => {
  const { isMultiSelect, onSelect, preset } = useMediaLibDialogCtx();
  const { toggleSelectedItem, selectedItems } = useMediaLibDialogStoreShallow(
    (s) => ({
      selectedItems: s.selectedItems,
      toggleSelectedItem: s.toggleSelectedItem,
    }),
  );
  const handleClick = (gifData: IGifs) => {
    if (preset === MediaLibPresetEnum.OnlyVideos) return;
    const url = gifData.preview?.webp || gifData.url;
    const item: IMediaLibDialogItem = {
      id: gifData.id,
      url,
      type: "image",
      mediaFrom: "stock-image",
      shouldUpload: true,
    };

    if (!isMultiSelect) {
      onSelect(item);
      return;
    }

    toggleSelectedItem(item);
  };

  return (
    <Gifs
      view="dialog"
      onSelect={handleClick}
      selectedItems={selectedItems}
      isMultiSelect={isMultiSelect}
    />
  );
};
